import { Component, Input } from '@angular/core';
import { LiveClassTile } from '../../../live-class-section/class-tile/live-class-tile';
import { LiveClassLessonTrack } from '../../live-class-lesson-track-dto';
import { LiveClassWithCountdownTimerComponent } from '../../live-class-with-countdown-timer/live-class-with-countdown-timer.component';
import { PrivateClassLesson } from '../private-class-lesson-dto';

@Component({
  selector: 'lp2-private-class-state-none',
  template: `
    <lp2-private-class-left-header-banner [liveClassTile]="liveClassTile" [lessons]="lessons" [track]="track">
      <ng-container withTrack>
        <p class="fw-bold fs-6 lh-4 ml-auto mr-auto mb-2 mt-xl-0 mt-2">{{ labelKey | translate }}</p>
        <lp2-live-class-state-view-timer
          class="pt-2 pb-3 d-flex flex-column align-items-center"
          theme="dark"
          [minutes]="minutes"
          [seconds]="seconds"
        ></lp2-live-class-state-view-timer>
      </ng-container>
    </lp2-private-class-left-header-banner>
  `,
})
export class PrivateClassStateNoneComponent extends LiveClassWithCountdownTimerComponent {
  @Input() track: LiveClassLessonTrack;
  @Input() liveClassTile: LiveClassTile;
  @Input() lessons: Array<PrivateClassLesson>;
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-states/private-class-state-none.component.ts